import { render, staticRenderFns } from "./ghost-bs.vue?vue&type=template&id=4dc24bfa&"
import script from "./ghost-bs.vue?vue&type=script&lang=js&"
export * from "./ghost-bs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ghost-bs.vue"
export default component.exports